import {launchCLI} from '@shopify/cli-kit/node/cli-launcher';

async function runOxygenCLI() {
  await launchCLI({
    moduleURL: import.meta.url,
  });
}

export default runOxygenCLI;
